import { useT } from '_metronic/i18n/Metronici18n'
import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { SetorClienteModal } from '../modal/SetorClienteModal'

export const SetorClienteListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openAddSetor = () => {
    showModal({
      title: 'Setor',
      content: <SetorClienteModal />,
      size: ModalSize.Medium,
    })
  }

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openAddSetor}>
      {t('common.add')}
    </Button>
  )
}
